import axios from 'axios'
import EventEmitter from 'eventemitter3'
import ConfigService from './ConfigService'

export default class BaseService extends EventEmitter {
  constructor(config) {
    super()
    config = {
      baseURL: () => ConfigService.get('api.base'),
      ...config
    }

    this.axios = axios.create()
    this.axios.defaults.withCredentials = true

    Object.defineProperty(this.axios.defaults, 'baseURL', {
      get() {
        if (typeof config.baseURL === 'function') {
          return config.baseURL()
        }

        return config.baseURL
      }
    })
  }

  get(url, config) {
    return this.axios.get(url, config)
  }

  post(url, data, config) {
    return this.axios.post(url, data, config)
  }

  put(url, data, config) {
    return this.axios.put(url, data, config)
  }

  patch(url, data, config) {
    return this.axios.patch(url, data, config)
  }

  delete(url, config) {
    return this.axios.delete(url, config)
  }
}
